import style from "./TablePagination.module.css";

import { padZero } from "@/utils/helpers";
import Icon from "@/ui/icon/Icon";

function TablePagination({ table, leftSection }) {
	const currentPageInfo = {
		from: Math.min(
			table.getState().pagination.pageIndex *
				table.getState().pagination.pageSize +
				1,
			table.getRowCount()
		),
		to: Math.min(
			(table.getState().pagination.pageIndex + 1) *
				table.getState().pagination.pageSize,
			table.getRowCount()
		),
	};

	return (
		<div className={style.pagination}>
			{leftSection}
			<span className={style.pageIndex}>
				{padZero(currentPageInfo.from)} - {padZero(currentPageInfo.to)}{" "}
				od {padZero(table.getRowCount())}
			</span>
			<button
				className={style.btn}
				onClick={() => table.previousPage()}
				disabled={!table.getCanPreviousPage()}
			>
				<Icon icon="fa-arrow-left" />
			</button>
			<button
				className={style.btn}
				onClick={() => table.nextPage()}
				disabled={!table.getCanNextPage()}
			>
				<Icon icon="fa-arrow-right" />
			</button>
		</div>
	);
}

export default TablePagination;
